import React from "react";
import { Image, Text, AspectRatio } from "@chakra-ui/react";

const DefaultFallback = ({ text }) => {
  return <Text fontSize={["1xl", "2xl", "4xl", "6xl", "8xl"]}>{text}</Text>;
};

const AspectPhoto = ({ src, alt, fallback, name, ...rest }) => {
  const initials =
    name &&
    name
      ?.split(" ")
      .map((n) => n[0])
      .filter(Boolean)
      .join("")
      .toUpperCase();
  return (
    <AspectRatio
      w={"full"}
      maxW="full"
      ratio={1}
      borderRadius={"full"}
      bg={"brand.primary.500"}
      borderColor={"brand.primary.300"}
      borderWidth={["8px", "10px"]}
      borderStyle={"solid"}
      {...rest}
    >
      <Image
        src={src}
        fallback={fallback || <DefaultFallback text={initials} />}
        alt={alt}
        borderRadius="full"
      />
    </AspectRatio>
  );
};

export default AspectPhoto;
